import { isUserLoggedIn } from 'redux/modules/sessions/selectors';

import urls from 'constants/urls';

const loggedInRoutes = [
  { path: urls.bookslot },
  { path: urls.boughtInStore },
  { path: urls.favourites },
  { path: urls.interstitials },
  { path: urls.lists },
  { path: urls.myAccount },
  { path: urls.myDetailsPage },
  { path: urls.moreOfWhatYouLove },
  { path: urls.orderReplacementCard },
  { path: urls.quickShop },
  { path: urls.shopFromPreviousInterstitial },
  { path: urls.shopByList },
  { path: '/ecom/shopping-lists' },
  { path: urls.trolleyPage },
];

const pathInRouteList = (routeList = [], pathname = '') =>
  routeList.filter(({ path }) => pathname.startsWith(path));

export const isAuthorised = ({ location: { pathname }, store: { getState } }) => {
  const matchingPaths = isUserLoggedIn(getState()) ? [] : pathInRouteList(loggedInRoutes, pathname);
  return matchingPaths.length === 0;
};
